




































































import defaultComponent from "../utils/defaultComponent";
import merge from "../utils/merge";

export default defaultComponent.apply({
  props: [],
  data() {
    return {
      selfDisabled: false
    };
  },
  computed: {
    disabledState() {
      if (this.enabled) {
        return !this.enabled.value;
      }
      if (this.disabled) {
        return this.disabled.value;
      }
      return this.selfDisabled;
    }
  },
  methods: {
    initialize() {},
    setDisabled(value: boolean) {
      if (this.enabled) {
        this.enabled.value = !value;
      } else if (this.disabled) {
        this.disabled.value = value;
      } else {
        this.selfDisabled = value;
      }
    }
  },
  extraOptions: {
    defaultType: "v-btn",
    defaultClass: "btn",
    forwardEvents: {
      click: "xClick"
    },
    forwardStates: {
      xEnabled: ["enabled", false, true],
      xDisabled: ["disabled", false, true],
      xLoading: ["loading", false]
    }
  }
});
